import { Form } from "@components";
import React from "react";
import { Employee } from "../../../../../../store";

interface Props {
  data: Employee | undefined;
  onHandleChange: (key: any, any: any) => void;
  form: any;
}

type FormValues = {
  id: number;
  email: string;
  location: string;
  userNtLogin: string;
  managerEmail: string;
  vpemail: string;
  svpemail: string;
  secondManagerEmail: string;
  active: boolean;
  divestitureCode: string;
  networkId: string;
};

type Key = keyof FormValues;

export const FormData: React.FC<Props> = ({ data, onHandleChange, form }) => {
  return (
    <Form>
      <Form.Textbox
        label="Employee Email"
        name="email"
        onChange={onHandleChange}
        size={12}
        value={form.values.email}
        error={form.errors.email}
        maxLength={80}
      />
      <Form.Textbox
        label="Employee ID"
        name="userNtLogin"
        onChange={onHandleChange}
        size={12}
        value={form.values.userNtLogin}
        error={form.errors.userNtLogin}
        maxLength={80}
      />
      <Form.Textbox
        label="Network ID (For Service Manager ticket creation)"
        name="networkId"
        onChange={onHandleChange}
        size={12}
        value={form.values.networkId}
        error={form.errors.networkId}
        maxLength={80}
      />
      <Form.Textbox
        label="Location"
        name="location"
        onChange={onHandleChange}
        size={12}
        value={form.values.location}
        error={form.errors.location}
        maxLength={80}
      />
      <Form.Textbox
        label="Manager Email"
        name="managerEmail"
        onChange={onHandleChange}
        size={12}
        value={form.values.managerEmail}
        error={form.errors.managerEmail}
        maxLength={80}
      />
      <Form.Textbox
        label="Second Manager Email"
        name="secondManagerEmail"
        onChange={onHandleChange}
        size={12}
        value={form.values.secondManagerEmail}
        maxLength={80}
        error={form.errors.secondManagerEmail}
      />
      <Form.Textbox
        label="VP Email"
        name="vpemail"
        onChange={onHandleChange}
        size={12}
        value={form.values.vpemail}
        maxLength={80}
        error={form.errors.vpemail}
      />
      <Form.Textbox
        label="SVP Email"
        name="svpemail"
        onChange={onHandleChange}
        size={12}
        value={form.values.svpemail}
        maxLength={80}
        error={form.errors.svpemail}
      />
      <Form.Textbox
        label="Divestiture Code"
        name="divestitureCode"
        onChange={onHandleChange}
        size={12}
        value={form.values.divestitureCode}
        maxLength={80}
        error={form.errors.divestitureCode}
      />
      <Form.Checkbox
        label="Is Active"
        name="active"
        onChange={onHandleChange}
        size={6}
        value={form.values.active}
      />
    </Form>
  );
};
